import MyCalculationsAgent from "../views/MyCalculationsAgent.vue";

const menu = [
  { title: "Реестр расчетов", icon: "file_copy", url: "/calculations", id: 4 },
];

const routes = [
  {
    path: "/calculations",
    component: MyCalculationsAgent,
    meta: {
      forAuth: true,
    },
  },
];

export default { menu, routes };
